import ResultClickedEventRecord from "models/view-models/events/result-clicked-event.record";
import SearchSubmittedEventRecord from "models/view-models/events/search-submitted-event.record";
import ConversationEventRecord from "models/view-models/events/conversation-event.record";
import MessageEventRecord from "models/view-models/events/message-event.record";
import ToolCallEventRecord from "models/view-models/events/tool-call-event.record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const baseEndpoint = "events";
const searchSubmittedEventResourceType = SearchSubmittedEventRecord;
const resultClickedEventRecordResourceType = ResultClickedEventRecord;

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Service
// -----------------------------------------------------------------------------------------

const EventsService = {
    useSearchSubmittedEvent:
        ServiceHookFactory.useCreate<SearchSubmittedEventRecord>(
            searchSubmittedEventResourceType,
            baseEndpoint
        ),
    useResultClickedEvent:
        ServiceHookFactory.useCreate<ResultClickedEventRecord>(
            resultClickedEventRecordResourceType,
            baseEndpoint
        ),
    useConversationEvent: ServiceHookFactory.useCreate<ConversationEventRecord>(
        ConversationEventRecord,
        baseEndpoint
    ),
    useMessageEvent: ServiceHookFactory.useCreate<MessageEventRecord>(
        MessageEventRecord,
        baseEndpoint
    ),
    useToolCallEvent: ServiceHookFactory.useCreate<ToolCallEventRecord>(
        ToolCallEventRecord,
        baseEndpoint
    ),
};

// #endregion Service

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default EventsService;

// #endregion Exports
